export const scrollToSection = (className, offset = 50) => {
    window.scrollTo({
        top: document?.querySelector(`.${className}`)?.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth',
    });
};

export const with404Page = async (request, navigate) => {
    const { error } = await request;
    if (error?.message === 'Request failed with status code 404') {
        navigate('/404');
    }
};

export const getCookie = cname => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
